import React, { useState, useMemo, useEffect, useContext, useRef, useImperativeHandle, forwardRef } from 'react'
import { message as mes, request } from 'meinian-package/src/utils'
import MNWaterfallApi from 'component/waterfall/masonryApi'
import { Card } from 'component'
import StyleMultiGraph from 'component/waterfall.card/style/styleMultiGraph'
import Empty from 'meinian-package/src/baseComponent/empty'
import util from 'meinian-package/src/utils/util'
import emitter from 'meinian-package/src/utils/emitter'
import { AccountContext } from 'context'
import useNeedMarkTimes from 'common/hooks/useNeedMarkTimes'
import { useRequest } from 'ahooks'
import { SwitchPageTab, SwitchTabBorder } from '../../../components/switchTab'
import AuditSort from './auditSort'
import StatusSelect from './statusSelect'
import EmptySubTitle from './emptySubTitle'
import { EmitterEvents } from '../header'
import { RULES, getRules } from '../../../components/fixedOperation/imageSize'
import { VIEW_MODE } from '../../../components/fixedOperation'
import { getViewConfig } from '../../../../component/navUser/viewSettingModal'
import styles from './index.module.less'

const TABS = { collect: 1, audit: 2 }

export default forwardRef(({ columnRulesType, viewMode }, ref) => {
  const account = useContext(AccountContext)
  const [tab, setTab] = useState(TABS.collect)
  const [sortValue, setSortValue] = useState(null)
  const [auditSortValue, setAuditSortValue] = useState(null)
  const [markTimes, setMarkTimes] = useState(null)
  const [auditCount, setAuditCount] = useState(0)
  const [isRefresh, setIsRefresh] = useState(false)
  const switchOption = useNeedMarkTimes({})
  const onTab = (val) => {
    setTab(val)
    if (val === TABS.collect) {
      setAuditSortValue(null)
      setMarkTimes(null)
    }
  }
  const params = useMemo(() => {
    if (tab === TABS.collect) {
      return {
        rankStatus: 1,
        sortOrderStatus: 0,
        markStatus: sortValue,
        userIdList: [account?.userInfo?.userId]
      }
    }
    return {
      queryType: 'pending_my_mark',
      userIdList: auditSortValue ? [auditSortValue] : null,
      markTimes
    }
  }, [tab, auditSortValue, markTimes, sortValue, account])
  // 获取待我审核数量
  const { run: fetchAuditCount } = useRequest(() => request.post('/zhikuan/image-bus/inspiration/list-blog', {
    pageSize: 1,
    start: 0,
    queryType: 'pending_my_mark',
    userIdList: auditSortValue ? [auditSortValue] : null,
    markTimes
  }), {
    refreshDeps: [auditSortValue, markTimes],
    onSuccess: (result) => {
      setAuditCount(result.resultCount)
    }
  })

  const tabsOption = useMemo(() => {
    return [{ label: '最近采集', value: 1 }, { label: '待我审核', value: 2, num: auditCount }]
  }, [auditCount])

  const $masonry = useRef(null)
  useEffect(() => {
    const subUploadImage = () => { $masonry.current?.init() }
    mes.sub('onMNUploadImage', subUploadImage)
    return () => {
      mes.remove('onMNUploadImage')
    }
  }, [])

  useEffect(() => {
    emitter.emit(EmitterEvents.receiveWorkBenchHeader, { options: tabsOption, switchOption, tab, sortValue, auditSortValue })
    emitter.on(EmitterEvents.sendWorkbenchHeader, (message) => {
      if (message.start) {
        onTab(message.tab)
        setSortValue(message.sortValue)
        if (auditSortValue !== message.auditSortValue) {
          setAuditSortValue(message.auditSortValue)
        }
      }
    })
    return () => {
      emitter.off(EmitterEvents.sendWorkbenchHeader)
    }
  }, [auditCount, switchOption, tab, sortValue, auditSortValue])

  useImperativeHandle(ref, () => ({
    onInit: () => {
      $masonry.current?.init()
    }
  }))

  const [viewConfig, setViewConfig] = useState({})
  useEffect(() => {
    getViewConfig().then(res => {
      setViewConfig(res)
    })
  }, [])

  return (<div className={styles['mn-workbench-list']}>
    <div style={{ margin: '16px 0 24px 0' }} id="mn-workbench-list-page-tab">
      <SwitchPageTab
        options={tabsOption}
        value={tab}
        onChange={(val) => {
          util.track('mn-workbench-click', {
            module1: '款式查看',
            module2: '最近采集',
          })
          onTab(val)
        }}
        renderRight={() => <div>
          {
      tab === TABS.collect ? <SwitchTabBorder options={switchOption} value={sortValue} onChange={(val) => { setSortValue(val) }} />
        : <>
          <StatusSelect value={markTimes} onChange={(item) => setMarkTimes(item?.value)} />
          <AuditSort
            value={auditSortValue}
            onChange={(item) => {
              setAuditSortValue(item?.value)
            }}
          />
        </>
    }
        </div>}
      />
    </div>
    <MNWaterfallApi
      ref={$masonry}
      idKey={['imageGroupEntityId', 'inspirationId']}
      onRefresh={() => {
        if (tab === TABS.collect) {
          fetchAuditCount()
        } else if (tab === TABS.audit) {
          if (markTimes) {
            fetchAuditCount()
            setIsRefresh(!isRefresh)
          }
        }
      }}
      renderItem={(props) => {
        if (viewMode === VIEW_MODE.MULTI_GRAPH) {
          return <StyleMultiGraph {...props} />
        }
        if (viewMode === VIEW_MODE.IMAGE) {
          return <Card.Image {...props} />
        }
        if (viewMode === VIEW_MODE.TEXT) {
          return <Card.ImageText {...props} />
        }
        return <Card.Image {...props} />
      }}
      rule={viewMode === VIEW_MODE.IMAGE ? getRules(columnRulesType) : RULES.M}
      cardProps={{
        showMoveImage: true,
        allStyleFlag: true,
        trackSourceType: '工作台',
        trackModule2: tab === TABS.collect ? '最近采集' : '待我审核',
        viewConfig
      }} // allStyleFlag 区别于灵感集的硬编码
      url="/image-bus/inspiration/list-blog"
      method="spost"
      params={{
        ...params,
        isRefresh
      }}
      empty={tab === TABS.collect ? <Empty
        title="最近暂无采集款式"
        type="image"
        subTitle={<EmptySubTitle />}
      /> : <Empty title="暂无相关款式" type="audit" subTitle="你有审核权限的灵感集中提交审核的款式都将展示在此处" />}
    />
  </div>)
})
